import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from '@/lib/api';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Bell } from "lucide-react";
import { BACKEND_URL } from "../config";
export function NotificationLoginPopup({ onOpenNotifications }) {
  const { t } = useTranslation("notifications");
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    // Check if we should show the popup (only once per session)
    const hasShownPopup = sessionStorage.getItem("notification_popup_shown");
    if (hasShownPopup) return;

    const checkUnread = async () => {
      try {
        const res = await api.get("/api/notifications/unread-count");
        const count = res.data.unread_count || 0;
        if (count > 0) {
          setUnreadCount(count);
          setIsOpen(true);
          sessionStorage.setItem("notification_popup_shown", "true");
        }
      } catch (error) {
        // User not authenticated or other error - ignore
      }
    };

    // Small delay to let the page load
    const timer = setTimeout(checkUnread, 1500);
    return () => clearTimeout(timer);
  }, []);

  const handleViewNotifications = () => {
    setIsOpen(false);
    // Dispatch custom event to open the notification modal
    window.dispatchEvent(new CustomEvent('openNotificationsModal'));
    // Also call the callback if provided
    onOpenNotifications?.();
  };

  const handleDismiss = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-sm" data-testid="notification-login-popup">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <div className="flex items-center justify-center h-10 w-10 rounded-full bg-primary/20">
              <Bell className="h-5 w-5 text-primary" />
            </div>
            <span>{t("login_popup.title")}</span>
          </DialogTitle>
        </DialogHeader>
        
        <div className="py-4">
          <p 
            className="text-muted-foreground"
            dangerouslySetInnerHTML={{ 
              __html: unreadCount === 1 
                ? t("login_popup.message", { count: unreadCount })
                : t("login_popup.message_plural", { count: unreadCount })
            }}
          />
        </div>

        <DialogFooter className="flex gap-2 sm:justify-between">
          <Button variant="outline" onClick={handleDismiss} data-testid="dismiss-notification-popup">
            {t("login_popup.later")}
          </Button>
          <Button onClick={handleViewNotifications} data-testid="view-notifications-btn">
            <Bell className="h-4 w-4 mr-2" />
            {t("login_popup.view")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default NotificationLoginPopup;
